const styles = {
  downloadButtonBox: { alignSelf: 'flex-end' },
  downloadButton: { display: 'flex', gap: '0.5rem', alignItems: 'center' },
};
export default styles;
